import { useCallback, useState } from 'react';
import { useSubscriptionCancellation } from './useSubscriptionCancellation';
import {
  dismissPlanChange,
  isPlanChangeDismissed,
  selectSubscriptionNotice,
  SubscriptionNotice,
} from '../subscriptionNotice';

type SubscriptionNoticeReturn = {
  notice: SubscriptionNotice | null;
  dismiss: () => void;
};

/**
 * The subscription notice to show under the nav bar (cancellation, scheduled
 * plan change or completed plan change). Only the completed plan change can
 * be dismissed; the dismissal is remembered per ramp in localStorage.
 */
export const useSubscriptionNotice = (): SubscriptionNoticeReturn => {
  const {
    isScheduledForCancellation,
    scheduledCancelDate,
    scheduledPlanChange,
    lastPlanChange,
  } = useSubscriptionCancellation();
  const [dismissedRampId, setDismissedRampId] = useState<string | null>(null);

  const notice = selectSubscriptionNotice({
    isScheduledForCancellation,
    scheduledCancelDate,
    scheduledPlanChange,
    lastPlanChange,
    isDismissed: (rampId) => rampId === dismissedRampId || isPlanChangeDismissed(rampId),
  });

  const dismiss = useCallback(() => {
    if (notice?.kind !== 'planChanged') return;
    dismissPlanChange(notice.change.rampId);
    setDismissedRampId(notice.change.rampId);
  }, [notice]);

  return { notice, dismiss };
};
